import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import { BrowserRouter, Route,Router, Switch,Link } from 'react-router-dom';
import About from './about.js'
import Download from './download.js'
import Contact from './contact.js'
import SiteRoutes from './routes.js'

export default class Header extends Component {
    render() {
        return (
            <div className="site-header">
            <BrowserRouter>
                <Link target="_blank"  to={"/usaquake-website"}>Home </Link>
            </BrowserRouter>
            <SiteRoutes/>
           </div>
        )
    }      
}